import { render, staticRenderFns } from "./sysNotice.vue?vue&type=template&id=13c9b0dd&scoped=true&"
import script from "./sysNotice.vue?vue&type=script&lang=js&"
export * from "./sysNotice.vue?vue&type=script&lang=js&"
import style0 from "./sysNotice.vue?vue&type=style&index=0&id=13c9b0dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c9b0dd",
  null
  
)

export default component.exports